import { Link } from "react-router-dom";
import ZaloLink from "./ZaloLink";
import { useGlobalSettings } from "../../hooks/useGlobalSettings";

const Footer = () => {
  const { settings } = useGlobalSettings();
  return (
    <footer className="bg-[#001428] text-white">
      {/* Main Footer Content */}
      <div className="max-w-[1100px] mx-auto px-6 py-8">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-0">
          {/* ===== LEFT: KCANIA ===== */}
          <div className="flex-1 grid grid-cols-1 sm:grid-cols-2 gap-8">
            {/* KCANIA Brand */}
            <div>
              <div className="flex items-center gap-2 mb-3">
                <img
                  src="https://static.readdy.ai/image/302c4174898c881693fe2d12476be64a/fcb736df9a5a33bf7d4c294e6dc25119.png"
                  alt="KCANIA"
                  className="h-10 w-auto object-contain flex-shrink-0"
                />
                <span className="text-white font-semibold text-xs leading-tight">KOREA CARBON AND NANO INDUSTRY ASSOCIATION</span>
              </div>
              <p className="text-gray-400 text-xs leading-relaxed mb-3">
                Hiệp hội các doanh nghiệp trong lĩnh vực công nghiệp Carbon và Nano, thúc đẩy hệ sinh thái công nghiệp, đảm bảo khả năng cạnh tranh toàn cầu cho các doanh nghiệp Carbon/Nano và phát triển ngành công nghiệp.
              </p>
              {/* KCANIA Social */}
              <div className="flex items-center gap-2">
                <a
                  href="https://www.facebook.com/profile.php?id=61572163886566"
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="w-7 h-7 flex items-center justify-center rounded-lg bg-white/10 hover:bg-[#1877F2]/30 text-gray-400 hover:text-[#1877F2] transition-all cursor-pointer"
                  title="Facebook"
                >
                  <i className="ri-facebook-fill text-xs" />
                </a>
                <a
                  href="https://www.kcania.or.kr/html/"
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="w-7 h-7 flex items-center justify-center rounded-lg bg-white/10 hover:bg-[#00AEEF]/30 text-gray-400 hover:text-[#00AEEF] transition-all cursor-pointer"
                  title="Website"
                >
                  <i className="ri-global-line text-xs" />
                </a>
              </div>
            </div>

            {/* KCANIA Contact */}
            <div>
              <h4 className="font-semibold text-white mb-3 text-xs uppercase tracking-wider">Liên Hệ</h4>
              <ul className="space-y-2">
                <li className="flex items-start gap-2">
                  <div className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                    <i className="ri-map-pin-line text-[#00AEEF] text-xs" />
                  </div>
                  <div className="text-gray-400 text-xs leading-relaxed">
                    <p className="font-medium text-gray-300">Head Office:</p>
                    <p>Room 1105, Building 2, Korea Science and Technology Center, 22 Teheran-ro 7-gil, Gangnam-gu, Seoul.</p>
                  </div>
                </li>
                <li className="flex items-center gap-2">
                  <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                    <i className="ri-phone-line text-[#00AEEF] text-xs" />
                  </div>
                  <span className="text-gray-400 text-[11px] sm:text-xs whitespace-nowrap">+82-2-6951-3921</span>
                </li>
                <li className="flex items-center gap-2">
                  <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                    <i className="ri-phone-line text-[#00AEEF] text-xs" />
                  </div>
                  <span className="text-gray-400 text-[11px] sm:text-xs whitespace-nowrap">Fax: +82-2-6951-2530</span>
                </li>
                <li className="flex items-start gap-2">
                  <div className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                    <i className="ri-mail-line text-[#00AEEF] text-xs" />
                  </div>
                  <span className="text-gray-400 text-xs">kcania@kcania.or.kr</span>
                </li>
                <li className="flex items-start gap-2">
                  <div className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                    <i className="ri-global-line text-[#00AEEF] text-xs" />
                  </div>
                  <span className="text-gray-400 text-xs">www.kcania.or.kr</span>
                </li>
              </ul>
            </div>
          </div>

          {/* ===== Divider ===== */}
          <div className="hidden lg:block w-px bg-white/10 self-stretch mx-6" />

          {/* ===== RIGHT: Bizwell ===== */}
          <div className="flex-1 grid grid-cols-1 sm:grid-cols-2 gap-8">
            {/* Bizwell Brand */}
            <div>
              <Link
                to="/login"
                className="flex items-center gap-2 mb-3 cursor-pointer group"
                title="Admin Login"
              >
                <img
                  src="https://storage.readdy-site.link/project_files/5f2724b2-0dd8-4526-ab2c-c1f8f3f4c6d1/3cc34f5d-4efb-4080-b20e-609cb6583db6_Logo-Bizwell-xa-nn.png?v=9759be03d333b1af02dd06dcbd6063e1"
                  alt="Bizwell"
                  className="h-8 w-auto object-contain flex-shrink-0 transition-transform group-hover:scale-105"
                  style={{ mixBlendMode: "screen" }}
                />
                <span className="text-white font-semibold text-xs leading-tight">CÔNG TY TNHH BIZWELL</span>
              </Link>
              <p className="text-gray-400 text-xs leading-relaxed mb-3">
                Nền tảng kết nối doanh nghiệp Hàn Quốc với thị trường Việt Nam.
                Cầu nối tin cậy cho hợp tác thương mại bền vững.
              </p>
              {/* Bizwell Social */}
              <div className="flex items-center gap-2">
                <a
                  href={settings.facebook_url}
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="w-7 h-7 flex items-center justify-center rounded-lg bg-white/10 hover:bg-[#1877F2]/30 text-gray-400 hover:text-[#1877F2] transition-all cursor-pointer"
                  title="Facebook"
                >
                  <i className="ri-facebook-fill text-xs" />
                </a>
                <a
                  href={settings.website_url}
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="w-7 h-7 flex items-center justify-center rounded-lg bg-white/10 hover:bg-[#00AEEF]/30 text-gray-400 hover:text-[#00AEEF] transition-all cursor-pointer"
                  title="Website"
                >
                  <i className="ri-global-line text-xs" />
                </a>
                <ZaloLink className="w-7 h-7 flex items-center justify-center rounded-lg bg-white/10 hover:bg-[#0068FF]/30 text-gray-400 hover:text-[#0068FF] transition-all cursor-pointer" title="Zalo" tooltipPosition="top">
                  <i className="ri-message-3-fill text-xs" />
                </ZaloLink>
              </div>
            </div>

            {/* Bizwell Contact */}
            <div>
              <h4 className="font-semibold text-white mb-3 text-xs uppercase tracking-wider">Liên Hệ</h4>
              <ul className="space-y-2">
                <li className="flex items-start gap-2">
                  <div className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                    <i className="ri-map-pin-line text-[#00AEEF] text-xs" />
                  </div>
                  <div className="text-gray-400 text-xs leading-relaxed">
                    <p>LE.0354, LE.0355, Chung cư Lexington, 67 Mai Chí Thọ</p>
                    <p>Phường Bình Trưng, TPHCM</p>
                  </div>
                </li>
                <li className="flex items-center gap-2">
                  <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                    <i className="ri-phone-line text-[#00AEEF] text-xs" />
                  </div>
                  <span className="text-gray-400 text-[11px] sm:text-xs whitespace-nowrap">{settings.hotline}</span>
                </li>
                <li className="flex items-center gap-2">
                  <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                    <i className="ri-phone-line text-[#00AEEF] text-xs" />
                  </div>
                  <span className="text-gray-400 text-[11px] sm:text-xs whitespace-nowrap">+84 28 6288 4688</span>
                </li>
                <li className="flex items-start gap-2">
                  <div className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                    <i className="ri-mail-line text-[#00AEEF] text-xs" />
                  </div>
                  <span className="text-gray-400 text-xs">bizwell@bizwell.com.vn</span>
                </li>
                <li className="flex items-start gap-2">
                  <div className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                    <i className="ri-global-line text-[#00AEEF] text-xs" />
                  </div>
                  <span className="text-gray-400 text-xs">www.bizwell.com.vn</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10 bg-[#004A99]/20">
        <div className="max-w-[1100px] mx-auto px-6 py-3 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-gray-400 text-[11px] sm:text-xs">
            Hosted by Triviet | © 2026 Bizwell Co., Ltd. Bản quyền thuộc về Hiệp Hội Công Nghiệp Carbon Nano Hàn Quốc.
          </p>
          <div className="flex items-center gap-4">
            {["Chính Sách Bảo Mật", "Điều Khoản Sử Dụng", "Liên Hệ"].map((item) => (
              <a key={item} href="#" className="text-gray-400 hover:text-white text-xs transition-colors cursor-pointer whitespace-nowrap">{item}</a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;